import React from 'react';
import { useNavigate, useSubmit, useActionData, useLoaderData, redirect } from 'react-router-dom';
import { ContentFrame } from '../../components/content_frame/content_frame';
import { getModel, getCnpjText, setInputCursor } from '../../utils/functions';
import { DESKTOP_PATH, CLINIC_LIST_PATH, CLINIC_ADD_PATH, CLINIC_EDIT_PATH, LOGIN_PATH } from '../../constants/paths';
import { CLINIC_GET_API } from '../../constants/apis';
import { ClinicData } from './clinic_data';


const DEFAULT_CLINIC = {
  email: "",
  name: "",
  cnpj: "",
  notes: "",
  is_active: true
};

export async function clinicAddLoader() {
  return DEFAULT_CLINIC;
};

export async function clinicEditLoader({ params }) {
  try {
    return await getModel(`${CLINIC_GET_API}${params.clinic_id}`);
  }
  catch(errors) {
    if(errors instanceof Array) {
      for(let error of errors) {
        if(error.code === 209) {
          // Expired user session
          return redirect(LOGIN_PATH);
        }
        else if(error.code === 203) {
          // Not authorized
          return redirect(DESKTOP_PATH);
        }
      }
    }

    throw errors;    
  }
};


class Clinic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clinic: {
        ...this.props.clinic
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.clinic !== this.props.clinic) {
      this.setState({
        clinic: {
          ...this.props.clinic
        }
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if(value && name === 'cnpj') {
      const initialPosition = target.selectionStart;
      const initialSize = value.length;

      value = value.replace(/\D/g,"");
      target.value = getCnpjText(value);

      let newPosition = (target.value.length - initialSize) + initialPosition;

      if(initialPosition < initialSize) {
        newPosition = initialPosition;
      }
      
      const currentValue = this.state.clinic[name] || '';

      const valueIncreased = currentValue.length < value.length;

      if(value.length > 2 &&
          (newPosition === 3)) {
        newPosition = valueIncreased ? 4 : 2;
      }
      else if(value.length > 5 &&
          (newPosition === 7)) {
        newPosition = valueIncreased ? 8 : 6;
      }
      else if(value.length > 8 &&
          (newPosition === 11)) {
        newPosition = valueIncreased ? 12 : 10;
      }
      else if(value.length > 12 &&
          (newPosition === 16)) {
        newPosition = valueIncreased ? 17 : 15;
      }

      setInputCursor(target, newPosition);
    }

    const newData = {...this.state.clinic, [name]: value};

    this.setState({
      clinic: newData
    });
  }

  inputsAreValid() {    
    return this.state.clinic.name.length > 0 &&
           this.state.clinic.email.match(/.+@.+\..+/) != null;
  }

  clearWarningMessage() {
    this.props.submit(
      {resetWarnings: true}, 
      {
        method: 'POST',
        encType: "application/json"
      });
  }

  async saveData() {
    let data = {...this.state.clinic};
    
    this.props.submit(
      {data}, 
      {
        method: this.props.isEdit ? 'PATCH' : 'POST',
        encType: "application/json"
      });
  }

  render() {
    return (
      <ContentFrame
        headerHistory={[
          {
            path: DESKTOP_PATH,
            text: "Área de trabalho"
          },
          {
            path: CLINIC_LIST_PATH,
            text: "Listar clientes"
          },
          {
            path: this.props.isEdit ? CLINIC_EDIT_PATH : CLINIC_ADD_PATH,
            text: this.props.isEdit ? 'Editar cliente' : 'Adicionar cliente'
          },
        ]}
        titleIcon={this.props.isEdit ? <i className="fas fa-edit"></i> : <i className="fas fa-plus"></i>}
        title={this.props.isEdit ? 'Editar cliente' : 'Adicionar cliente'}
      >

        <ClinicData
          warningMessage={this.props.warningMessage}
          showWarningMessage={this.props.warningMessage.length > 0}
          clinic={this.state.clinic}
          onSave={() => this.saveData()}
          onCloseWarning={() => this.clearWarningMessage()}
          enableSave={this.inputsAreValid()}
          handleInputChange={(event) => this.handleInputChange(event)}
          highlights={this.props.parametersToHighlight}
          onCancelPath={CLINIC_LIST_PATH}
        />

      </ContentFrame>
    );
  }
};

const WrappedClinic = props => {
  const clinic = useLoaderData();
  const navigate = useNavigate();
  const submit = useSubmit();
  const actionData = useActionData();

  let warningMessage = '';
  let parametersToHighlight = [];

  if (actionData) {
    warningMessage = actionData.message || '';
    parametersToHighlight = actionData.parameters || [];
  }  

  return (
    <Clinic
      navigate={navigate}
      submit={submit}
      warningMessage={warningMessage}
      parametersToHighlight={parametersToHighlight}
      clinic={clinic}
      {...props}
    />
  );
};

export { WrappedClinic as Clinic};
